import type { SVGProps } from 'react';

const SvgQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 42 32" {...props}>
    <path
      fill={props.color}
      d="M19.327 23.59q0 3.496-2.7 6.007Q14.036 32 10.041 32 5.4 32 2.7 28.724 0 25.447 0 20.969 0 10.812 5.506 5.68T17.706 0v7.427q-3.238.328-6.153 2.62-2.808 2.295-3.023 5.79a5.2 5.2 0 0 1 2.375-.547q3.995 0 6.154 2.294 2.268 2.293 2.267 6.006m22.673 0q0 3.496-2.7 6.007Q36.71 32 32.716 32q-4.644 0-7.342-3.276-2.592-3.277-2.591-7.755 0-10.157 5.398-15.29Q33.686.546 40.38 0v7.427q-3.238.328-6.154 2.62-2.807 2.295-3.023 5.79a5.2 5.2 0 0 1 2.375-.547q3.996 0 6.155 2.294Q42 19.877 42 23.59"
    />
  </svg>
);

export default SvgQuote;
